import {http} from 'hiya-common/src/utils/axios'

export async function is_hit_first_recharge() {
  const res = await http.post('live/misc/is_hit_first_recharge', {
    ...window.store.getState().env.deviceinfo,
  })
  return res.data.data
}
export enum recharge_type_enum {
  正常第三方支付 = 0,
  币商充值 = 1,
}
// [创建订单前的校验信息] http://wiki.xunlei.cn/pages/viewpage.action?pageId=127566187
export async function info_before_create_order(params: {
  product_id: string
  recharge_type: recharge_type_enum
}) {
  const res = await http.post<
    // 0不需要任何弹窗，不阻断 1仅弹窗提示，不阻断充值  2弹窗提示，且阻断充值
    HiyaRes<{err_msg: string; msg: string; status: 0 | 1 | 2}>
  >('/live/pay/info_before_create_order', {
    ...window.store.getState().env.deviceinfo,
    ...params,
  })
  return res.data.data
}

/** 【充值反馈】 http://wiki.xunlei.cn/pages/viewpage.action?pageId=142294955 */
export async function recharge_feedback(feedback_msg: string) {
  const res = await http.post<HiyaRes<any>>(
    '/live/pay/recharge_feedback',
    {
      ...window.store.getState().env.deviceinfo,
      ...{feedback_msg},
    },
    {
      noData: true,
    }
  )
  return res.data
}

/** 创建订单 */
export async function createRechargeOrderV2(params: {
  product_id: string
  pay_method_id: number
  from: string
  code: number
  source: string
  recharge_type: number
  /** 年度庆典新增参数 */
  activity_type?: 'annual_celebration'
  sub_activity_type?: 'time_limit' | 'stock_limit' | 'wealth_limit'
  pay_info?: {
    name: string
    email: string
    phone: string
  }
}) {
  const deviceInfo = window.store.getState().env.deviceinfo
  const resp = await http.post(
    '/live/pay/create_order_h5_v2',
    {
      ...deviceInfo,
      mid: deviceInfo.h_m,
      ...params,
    },
    {
      xcHideLog: true,
      xcErrorToast: true,
    }
  )
  return resp.data
}

/** 弹窗上报 */
export async function has_showed_feedback_popup() {
  const deviceInfo = window.store.getState().env.deviceinfo
  const resp = await http.post(
    '/live/pay/has_showed_feedback_popup',
    {
      ...deviceInfo,
    },
    {
      xcHideLog: true,
    }
  )

  return resp.data
}

export type ICountryItem = {
  area_code: number
  country: string
  region_code: number
  url: string
}
export type ICountryInfo = {
  host_list: ICountryItem[]
  list: ICountryItem[]
}
/** 获取国家信息 */
export async function get_country_info() {
  const resp = await http.post<HiyaRes<ICountryInfo>>(
    '/live/account/get_flag_list'
  )
  return resp.data
}

/** 我的卡券 */
/**
 * /live/pay/get_user_coupons
 * 获取用户卡券
 */
export type IUserCouponsReq = {
  /** 第一次请求是0，根据回传卡券最大idx确定下次翻页的此值，more由请求方已请求总条目数和返回的total比较可知 */
  // start_idx: number
  offset: number
  limit: number
  /** Weekly recharge */
  name?: string
}

export type IUserCouponsResp = {
  // ret: number
  // msg?: string
  // data: {
  err_msg: string
  total: number
  coupon_list: ICouponSt[]
  // }
}

export enum COUPON_TYPE_ENUM {
  /** 金币充返券 */
  COIN_RECHARGE = 1,
}

export enum COUPON_STATUS_ENUM {
  /** 可用，未使用 */
  UNUSED = 1,
  /** 不可用，时间未到 */
  NOT_IN_TIME = 0,
  /** 不可用，已使用 */
  USED = -1,
  /** 不可用，已过期 */
  EXPIRED = -2,
}
export type ICouponSt = {
  /** 卡券id */
  id: number
  /** 目前只有一种 1 金币充返券 */
  coupon_type: COUPON_TYPE_ENUM
  /** 状态 */
  status: COUPON_STATUS_ENUM
  /** 卡券信息 根据券的不同类型，ext内容不同 */
  ext: ICouponCoinExt
  /** 卡券生效时间 */
  st: number
  /** 卡券过期时间 */
  et: number
}
export type ICouponCoinExt = {
  /** 充返券反比 */
  inverse_ratio: number
  /** 充返券生效的充值挡位 */
  amount_level: number
  /** 充返券生效的充值币种 */
  currency: string
}

export const getUserCoupons = async (params: IUserCouponsReq) => {
  const resp = await http.post<HiyaRes<IUserCouponsResp>>(
    '/live/pay/get_user_coupons',
    {
      ...window.store.getState().env.deviceinfo,
      // name: 'Weekly recharge',
      ...params,
    }
  )

  return resp.data
}

export const getApplepaySession = async (params: {
  validation_url: any
  initiative_context: any
}) => {
  const resp = await http.post<HiyaRes<any>>(
    '/live/pay/airwallex_payment_session',
    {
      ...window.store.getState().env.deviceinfo,
      ...params,
    },
    {
      xcErrorToast: true,
    }
  )
  return resp.data.data
}

export type OrderExtInfo = {
  status: string
  respCode: string
  respMsg: string
  outOrderID: string
  client_secret: string
  currency: string
  pay_type: string
  pay_amount: number
  coins: number
}

export const get_order_ext_info = async (orderId: string) => {
  const resp = await http.post<HiyaRes<OrderExtInfo>>(
    `/live/pay/get_order_ext_info`,
    {
      ...window.store.getState().env.deviceinfo,
      order_id: orderId,
    },
    {
      xcErrorToast: true,
    }
  )
  return resp.data.data
}

export type ReturnUserInfo = {
  is_return_user: boolean // 是否回流老用户
  return_user_type: -1 | 1 | 2 | 3 // 1-无价值老用户 2-普通价值老用户 3-尊贵老用户 -1-非回流老用户
  show_return_user_recharge: boolean // 是否可以展示回归用户充值活动
  return_recharge_et: number // 优惠倒计时
  enable_return_gifts: boolean // 是否可触发回归礼物
  exp_group: boolean // 0-对照组 1-实验组
  server_ts: number // 服务端当前时间戳
}

export const get_is_return_olduser = async () => {
  const resp = await http.post<HiyaRes<ReturnUserInfo>>(
    `/live/facetime/is_returning_old_user`,
    {
      ...window.store.getState().env.deviceinfo,
      show_activity_page: true,
    },
    {
      xcErrorToast: true,
    }
  )
  return resp.data.data
}
